const getScriptsPath = () => {
  const script = document.querySelector('script[src*="build/js/"]');
  const src = script.src.split('?')[0];
  return src.split('/').slice(0, -1).join('/') + '/';
};

// set the public path to be the path of the main entry script
__webpack_public_path__ = getScriptsPath(); // eslint-disable-line
